module.exports = __webpack_public_path__ + "media/icon-megaphone.07a57362.svg";